import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

function IconButton({
  name,
  icon,
  tooltip,
  title,
  onClick,
  variant,
  style,
  useTestIds = true,
}) {
  return (
    <OverlayTrigger
      delay="500"
      placement="bottom"
      overlay={<Tooltip id={`tooltip-${name}`}>{tooltip}</Tooltip>}
    >
      <Button
        data-testid={useTestIds && title}
        title={title}
        size="sm"
        variant={variant}
        style={style}
        onClick={onClick}
      >
        {icon}
      </Button>
    </OverlayTrigger>
  );
}

IconButton.propTypes = {
  name: PropTypes.string,
  icon: PropTypes.object,
  tooltip: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  style: PropTypes.object,
  useTestIds: PropTypes.bool,
};

export default IconButton;
